import * as D from './deps';

const log = D.Logger.child({ component: 'krux/utils' });

function generateKruxUserMatchUrl(kruxListenerToken) {
  return `https://beacon.krxd.net/usermatch.gif?partner=pandora&partner_uid=${kruxListenerToken}`;
}

export function pingKrux(kruxListenerToken) {
  log.info('pingKrux(): pinging');
  const img = new Image();
  img.src = generateKruxUserMatchUrl(kruxListenerToken);
}
